import type { Product } from '@/types/api'
import { createCrudService } from '../crud'

export type ProductInput = Omit<Product, 'id' | 'created_at' | 'updated_at'>

export const productsService = createCrudService<Product, ProductInput>('products')
